import {
  QUERY_FETCH_SEARCH_COURSE_PAGEABLE,
  FetchSearchCoursesPageableQuery,
  FetchSearchCoursesPageableQueryVariables,
} from '@edwin-group/cj-graphql';
import { useMemo } from 'react';
import { useQueryCacheAndNetwork } from '@/hooks/useQueryCacheAndNetwork';
import { buildCoursesQueryVariables, SearchFilters } from '../utils/query-variables';

export const useCoursesSearch = (filters: SearchFilters, shouldSkip: boolean) => {
  const queryVariables = useMemo(() => buildCoursesQueryVariables(filters), [filters]);

  const {
    data: result,
    fetchMore,
    isInitialLoading,
  } = useQueryCacheAndNetwork<FetchSearchCoursesPageableQuery, FetchSearchCoursesPageableQueryVariables>(
    QUERY_FETCH_SEARCH_COURSE_PAGEABLE,
    {
      variables: queryVariables,
      skip: shouldSkip,
    },
  );

  const coursesList = result?.courses?.nodes;

  return {
    coursesList,
    fetchMore,
    isLoading: isInitialLoading,
    queryVariables,
    result,
  };
};
